let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7XW0W")).then(() => parcelRequire('beUK2'));